import React from 'react';

import DOMPurify from 'isomorphic-dompurify';
import Collapsible from 'react-collapsible';

import useWindowSize from '@components/common/hooks/useWindowSize';
import Text from '@components/common/Text/Text';
import { M_DEVICE } from '@components/lpc/Constants';
import OneQuestion from '@components/lpc/Help-center/SearchPage/OneQuestion/OneQuestion';
import ObjectService from '@services/utils/ObjectService';

import css from './DetailsContent.module.scss';

type DetailsContentProps = {
    searchedQuestion: number;
    searchedSubThematic?: number;
    thematicContent: any;
};

const DetailsContent = ({ searchedQuestion, thematicContent, searchedSubThematic }: DetailsContentProps) => {
    const { width } = useWindowSize();
    const renderTrigger = (subThematic) => {
        return (
            <div>
                <Text
                    customClass={css.question}
                    variant={width > M_DEVICE ? 'button_default' : 'button_small'}
                    color={'txt-primary'}
                >
                    {subThematic.titleST}
                </Text>
                <Text variant={'body_02'} color={'txt-secondary'}>
                    <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(subThematic.descriptionST) }} />
                </Text>
            </div>
        );
    };

    const displayQuestions = thematicContent?.miniQuestions.map((question, i) => (
        <OneQuestion
            key={`${question.questionID}${i}__question`}
            question={question}
            searchedQuestion={searchedQuestion}
        />
    ));
    return (
        <div className={css.details_content}>
            {ObjectService.hasContent(thematicContent) && ObjectService.hasContent(thematicContent.miniSubThematics) ? (
                <>
                    {thematicContent?.miniSubThematics.map((subThematic, i) => (
                        <>
                            <Collapsible
                                contentElementId={`collapsible-content-subthematics-${i}`}
                                triggerElementProps={{
                                    id: `collapsible-trigger-subthematics-${i}`,
                                }}
                                open={subThematic.subThematicID === searchedSubThematic}
                                key={`${subThematic.subThematicID}${i}__subThematic`}
                                classParentString={css.parent}
                                triggerClassName={css.trigger}
                                triggerOpenedClassName={css.trigger__opened}
                                contentInnerClassName={css.contentInner}
                                contentOuterClassName={css.contentOuter}
                                triggerTagName={'div'}
                                easing={'ease-in-out'}
                                trigger={renderTrigger(subThematic)}
                            >
                                {subThematic?.miniQuestions.map((question, i) => (
                                    <OneQuestion
                                        key={`${question.questionID}${i}__question`}
                                        question={question}
                                        searchedQuestion={searchedQuestion}
                                        customParentClass={'custom_parent'}
                                    />
                                ))}
                            </Collapsible>
                        </>
                    ))}
                    {displayQuestions}
                </>
            ) : (
                displayQuestions
            )}
        </div>
    );
};

export default DetailsContent;
